import React from 'react'
import { Outlet } from 'react-router'
import styled from '@emotion/styled'

import { CssBaseline } from '@mui/material'

import GlobalStyle from '../components/GlobalStyle'
import NavbarLanguagesDropdown from '../components/navbar/NavbarLanguagesDropdown'

const Root = styled.div`
    max-width: 520px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    display: flex;
    min-height: 100%;
    flex-direction: column;
    position: relative;
`

const LanguageBar = styled.div`
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 1;
`

const Auth = ({ children }: { children?: React.ReactNode }) => {
    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            <LanguageBar>
                <NavbarLanguagesDropdown />
            </LanguageBar>
            {children}
            <Outlet />
            {/* <Settings /> */}
        </Root>
    )
}

export default Auth
